import { fileNameHasDate } from './fileNameHasDate';
import { buildDateString } from './buildDateString';

const serveXLSX = async (report, title, appendDate = true) => {
    const fileName = !appendDate || fileNameHasDate(title) ? title : `${title}_${buildDateString()}`;
    const element = document.createElement('a');
    console.log('report', report);
    const blob = new Blob([report], { type: 'vnd.ms-excel;charset=utf-8' });

    element.setAttribute('href', URL.createObjectURL(blob));
    element.setAttribute('download', `${fileName}.xlsx`);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
};

export default serveXLSX;
